// src/authConfig.ts
const isLocalhost = window.location.hostname.includes("localhost");
const isPreview = window.location.hostname.includes("azurestaticapps.net");
export const clientId = "674e1192-afaf-4ad4-94f4-5f29a371359e"; 

// Determine the correct redirect URI based on environment
const getRedirectUri = (): string => {
  if (isLocalhost) {
    return "http://localhost:3000";
  } else if (isPreview) {
    // Use the actual deployed URL
    return window.location.origin;
  } else {
    // Custom domain 
    return "https://appconfig.thetrask.com"; // https://appconfig.thetrask.com
  }
};

export const msalConfig = {
    auth: {
      clientId: clientId, 
      authority: "https://login.microsoftonline.com/common/",
      redirectUri: getRedirectUri(),
    },
    cache: {
      cacheLocation: "sessionStorage", // sessionStorage for MSAL, localStorage for app and backup cache
      storeAuthStateInCookie: false,
    },
  };
  
export const loginRequest = {
  scopes: [
    "openid",           // Enables OpenID Connect and ID token
    "profile",          // Basic user profile info
    "offline_access",   // Enables refresh tokens - would be implictily granted with delegated permissions, but added here for clarity
    "User.Read",
    "Application.ReadWrite.All"
  ],
};
